import * as S from 'src/styles/styledcomponent/views/Rop02'

export const Rop02Header = () => {
  return (
    <>
      <S.HeaderWrap>
        <S.HeaderText>
          휴대폰가족보호 <span>이동통신사유료부가서비스</span>
        </S.HeaderText>
      </S.HeaderWrap>
      <S.HeaderHR />
    </>
  )
}
